{
  "name": "@systemfsoftware/trigger.dev_sdk",
  "version": "2.4.8",
  "description": "trigger.dev Node.JS SDK",
  "license": "MIT",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "module": "./dist/index.mjs",
  "publishConfig": {
    "access": "public"
  },
  "files": [
    "dist"
  ],
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.mts",
        "default": "./dist/index.mjs"
      },
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./v3": {
      "import": {
        "types": "./dist/v3/index.d.mts",
        "default": "./dist/v3/index.mjs"
      },
      "require": "./dist/v3/index.js",
      "types": "./dist/v3/index.d.ts"
    },
    "./package.json": "./package.json"
  },
  "typesVersions": {
    "*": {
      "v3": [
        "./dist/v3/index.d.ts"
      ]
    }
  },
  "scripts": {
    "prepare": "pnpm turbo build",
    "clean": "rimraf dist",
    "build": "pnpm run clean && pnpm run build:tsup",
    "build:tsup": "tsup --dts-resolve",
    "typecheck": "tsc --noEmit"
  },
  "dependencies": {
    "@opentelemetry/api": "^1.8.0",
    "@opentelemetry/api-logs": "^0.48.0",
    "@opentelemetry/semantic-conventions": "^1.22.0",
    "@systemfsoftware/trigger.dev_core": "workspace:^",
    "@systemfsoftware/trigger.dev_sdk-v2": "workspace:^",
    "@systemfsoftware/trigger.dev_core-backend": "workspace:^",
    "chalk": "^5.2.0",
    "cronstrue": "^2.21.0",
    "debug": "^4.3.4",
    "evt": "^2.4.13",
    "get-caller-file": "^2.0.5",
    "git-remote-origin-url": "^4.0.0",
    "git-repo-info": "^2.1.1",
    "msw": "^2.2.1",
    "slug": "^6.0.0",
    "terminal-link": "^3.0.0",
    "ulid": "^2.3.0",
    "uuid": "^9.0.0",
    "ws": "^8.11.0"
  },
  "peerDependencies": {
    "zod": "3.x",
    "effect": "3.x",
    "@effect/schema": "0.72.0"
  },
  "peerDependenciesMeta": {
    "effect": {
      "optional": false
    },
    "@effect/schema": {
      "optional": false
    },
    "zod": {
      "optional": false
    }
  },
  "devDependencies": {
    "effect": "^3.7.0",
    "@effect/schema": "0.72.0",
    "zod": "3.22.3",
    "@systemfsoftware/trigger.dev_tsconfig": "workspace:*",
    "@systemfsoftware/trigger.dev_tsup": "workspace:*",
    "@types/debug": "^4.1.7",
    "@types/node": "^20.16.2",
    "@types/slug": "^5.0.3",
    "@types/uuid": "^9.0.0",
    "@types/ws": "^8.5.3",
    "encoding": "^0.1.13",
    "msw": "^2.2.1",
    "rimraf": "^3.0.2",
    "tsup": "8.0.1",
    "typed-emitter": "^2.1.0",
    "typescript": "5.5.4"
  },
  "engines": {
    "node": ">=18.0.0"
  }
}
